import { useShowContext } from 'framework/show';
import { VendorDto } from 'domain/finance/vendors/types';
import CancelIcon from '@mui/icons-material/Cancel';
import { Typography } from '@mui/material';
import { useAuthorization } from 'framework/authorization';
import { VENDOR_PROFILE_STATUSES, VENDOR_REJECT, VENDOR_WORKING_STATUSES } from 'domain/finance/vendors/constants';
import { useNavigate } from 'react-router-dom';
import { useVendorId, useVendorsUrl } from 'domain/finance/vendors/routes';
import useVendorService from 'domain/finance/vendors/useVendorService';
import { ButtonWithConfirmation } from 'framework/ui/ui-builder';

const RejectVendorButton = ({ permissionToCheck = null }: { permissionToCheck?: Nullable<string> }) => {
  const id = useVendorId();
  const navigate = useNavigate();
  const { getListUrl } = useVendorsUrl();
  const { isGranted } = useAuthorization();

  const { rejectVendor } = useVendorService();
  const { data } = useShowContext<VendorDto>();

  const { isCompliant, profileStatus, workingStatus } = data.getData();

  const handleRejectAction = async () => {
    return rejectVendor(id);
  };

  return isGranted(VENDOR_REJECT) &&
    !isCompliant &&
    profileStatus === VENDOR_PROFILE_STATUSES.DRAFT &&
    workingStatus === VENDOR_WORKING_STATUSES.INACTIVE ? (
    <ButtonWithConfirmation
      link
      color="error"
      startIcon={<CancelIcon color="error" />}
      displayMessage="Do you really want to reject this vendor?"
      submitMethod={handleRejectAction}
      permissionToCheck={permissionToCheck}
      modalConfirmButtonText="Reject"
      afterSubmit={{
        execute: () => {
          navigate(getListUrl());
        },
      }}
      confirmBtnProps={{
        color: 'error',
      }}
    >
      <Typography color="error" variant="subtitle1">
        Reject
      </Typography>
    </ButtonWithConfirmation>
  ) : null;
};

export default RejectVendorButton;
